
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OverviewMetrics from "./analytics/OverviewMetrics";
import ArticlePerformance from "./analytics/ArticlePerformance";
import AudienceInsights from "./analytics/AudienceInsights";
import PublishingTimes from "./analytics/PublishingTimes";
import SubscriberAnalysis from "./analytics/SubscriberAnalysis";
import EngagementMetrics from "./analytics/EngagementMetrics";
import AIInteractions from "./analytics/AIInteractions";
import TagDistribution from "./analytics/TagDistribution";

const Analytics = () => {
  const [timeframe, setTimeframe] = useState<"7d" | "30d" | "90d" | "1y">("30d");

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-3xl font-bold text-directpress-blue dark:text-white">Analytics Dashboard</h2>
          <p className="text-muted-foreground">Track your content performance and audience engagement</p>
        </div>
        
        <div className="flex items-center gap-2">
          <Tabs defaultValue="30d" onValueChange={(value) => setTimeframe(value as "7d" | "30d" | "90d" | "1y")}>
            <TabsList>
              <TabsTrigger value="7d">7 Days</TabsTrigger>
              <TabsTrigger value="30d">30 Days</TabsTrigger>
              <TabsTrigger value="90d">90 Days</TabsTrigger>
              <TabsTrigger value="1y">1 Year</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>

      <OverviewMetrics timeframe={timeframe} />
      
      <Tabs defaultValue="articles" className="space-y-4">
        <TabsList className="grid grid-cols-3 md:grid-cols-7 w-full">
          <TabsTrigger value="articles">Articles</TabsTrigger>
          <TabsTrigger value="audience">Audience</TabsTrigger>
          <TabsTrigger value="publishing">Publishing</TabsTrigger>
          <TabsTrigger value="subscribers">Subscribers</TabsTrigger>
          <TabsTrigger value="engagement">Engagement</TabsTrigger>
          <TabsTrigger value="tags">Tags</TabsTrigger>
          <TabsTrigger value="ai">AI Insights</TabsTrigger>
        </TabsList>
        
        <TabsContent value="articles" className="space-y-4">
          <ArticlePerformance timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="audience" className="space-y-4">
          <AudienceInsights timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="publishing" className="space-y-4">
          <PublishingTimes timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="subscribers" className="space-y-4">
          <SubscriberAnalysis timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="engagement" className="space-y-4">
          <EngagementMetrics timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="tags" className="space-y-4">
          <TagDistribution timeframe={timeframe} />
        </TabsContent>
        
        <TabsContent value="ai" className="space-y-4">
          <AIInteractions timeframe={timeframe} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Analytics;
